import React from 'react';

const TabButton = ({ active, onClick, children, icon: Icon, count, disabled = false }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={`relative flex-shrink-0 whitespace-nowrap px-4 sm:px-6 py-3 sm:py-4 font-medium text-sm transition-all duration-300 rounded-xl flex items-center space-x-2 ${
      active
        ? 'text-blue-600 bg-blue-50 border border-blue-300 dark:text-blue-400 dark:bg-blue-500/10 dark:border-blue-500/30'
        : disabled
        ? 'text-gray-400 dark:text-gray-500 cursor-not-allowed'
        : 'text-gray-600 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-cream-900/5 dark:hover:bg-gray-800/50'
    }`}
  >
    <Icon size={18} />
    <span>{children}</span>
    {count !== undefined && (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${active ? 'bg-blue-500 text-white' : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300'}`}>
        {count}
      </span>
    )}
  </button>
);

export default TabButton;
